import styled from 'styled-components';
import { Button, Heading } from '@alefeducation/ui-elements-library-core';
import { Upload } from '@alefeducation/ui-elements-library-icons';
import { useState } from 'react';
import { AVATAR_UPLOAD, UPLOAD_FILE } from '../../utils/constants';
import AvatarUploadModal from '../AvatarUploadModal/AvatarUploadModal';

const Header = () => {
  const [isModalOpen, setModalOpen] = useState(false);

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  return (
    <StyledContainer
      data-testid="avatar-upload-header"
      id="avatar-upload-header"
    >
      <Heading variant="heading-small" color="primary.100">
        {AVATAR_UPLOAD}
      </Heading>
      <Button variant="primary" size="lg" icon={<Upload />} onClick={openModal}>
        {UPLOAD_FILE}
      </Button>
      {isModalOpen && (
        <AvatarUploadModal isOpen={isModalOpen} onClose={closeModal} />
      )}
    </StyledContainer>
  );
};

export default Header;

const StyledContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`;
